module.exports = __webpack_public_path__ + "img/mgc-logo.14325ec4.png";